import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  FieldSkeleton,
  SelectSkeleton,
  CheckboxSkeleton,
  ButtonSkeleton
} from '../../common/components/Skeleton';
import { Spacing } from '../../assets/GlobalStyle/Variables';

export const DeceasedFormSkeleton: FC = () => {
  return (
    <StyledForm>
      {/* Riadok 1: Jméno, Příjmení, Checkbox */}
      <Row>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
        <Col lg={4} md={12}>
          <CheckboxSkeleton />
        </Col>
      </Row>

      {/* Riadok 2: Tituly, Pohlaví */}
      <Row>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
      </Row>

      <Row>
        <Col lg={4} md={12}>
          <SelectSkeleton />
        </Col>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
      </Row>

      {/* Riadok 3: Datum narození, Datum úmrtí */}
      <Row>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
      </Row>

      {/* Riadok 4: RČ, Číslo pojistky, Button */}
      <Row>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
        <Col lg={4} md={12}>
          <FieldSkeleton />
        </Col>
        <Col lg={2} md={12}>
          <Skeleton height={30} width={150} style={{ marginTop: '24px' }} />
        </Col>
      </Row>

      {/* Riadok 5: Pojišťovna */}
      <Row>
        <Col lg={4} md={12}>
          <SelectSkeleton />
        </Col>
        <Col lg={6} md={12}>
          <FieldSkeleton />
          <FieldSkeleton />
        </Col>
      </Row>

      {/* Akčné tlačítka */}
      <StyledActionSection>
        <ButtonSkeleton width={100} />
        <ButtonSkeleton width={80} />
        <ButtonSkeleton width={100} />
      </StyledActionSection>
    </StyledForm>
  );
};

const StyledForm = styled.div`
  padding-top: 1.5rem;
`;

const StyledActionSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${Spacing(20)};
  gap: 10px;
`;
